import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import "./DataAnalytics.css";
import Button from "../../components/Button/Button";
import { Container, Row, Col, Card, Carousel } from "react-bootstrap";
import OfferingsTabs from "../../components/OfferingsTabs/OfferingsTabs";
import "bootstrap/dist/css/bootstrap.min.css";
import { data_analytics_caseStudies } from "../../StaticData/caseStudiesData";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import { FaArrowUp } from "react-icons/fa";
import data_img_1 from "../../assets/images/data_img_1.png";
import { Helmet } from "react-helmet";
import CaseStudies from "../../components/CaseStudies/CaseStudies";

const DataAnalytics = () => {
  const [currentIndex, setCurrentIndex] = useState(1);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="DataAnalytics-page">
       <Helmet>
        <title>Data and Analytics Services and Solutions | Idexcel</title>
        <meta
          name="description"
          content="Leverage cutting-edge data and analytics services and solutions to gain valuable insights, optimize operations, and drive smarter decisions. Unlock the power of data today!"
        />
      </Helmet>
      {/* //banner section  */}
      <section className="banner-section">
        <Container className="mt-5">
          <Row>
            <Col lg={12}>
              <div className="banner-overlay mt-5">
                <h1 className="banner-title mb-5">
                  Turn Data Into Decisions. <br />
                  At Scale and At Speed.
                </h1>
                <Button className="banner-button" size="large" color="banner">
                  <a href="/contact-us" className="text-white">
                    Contact Us
                  </a>

                  <FaArrowUp className="explore-arrow" />
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* section 2 */}

      <section
        className="image-text-section pt-5"
        style={{ backgroundColor: "#FEFFF3" }}
      >
        <Container>
          <Row className="custom-flex align-items-center">
            {/* Left Side: Image */}
            <Col lg={5} md={6} sm={12} className="image-box">
              <img src={data_img_1} alt="Tech Image" className="img-fluid" />
            </Col>

            {/* Right Side: Content */}
            <Col lg={6} md={6} sm={12} className="content-box">
              <h1 className="section-title">
                Drowning in Data But Starving For Insights?
              </h1>
              <p className="section-text">
                Unify data, enhance quality, and deploy AI-driven analytics for
                real-time insights. Leverage cloud-native architectures to
                process data, optimize workflows, and drive automation for
                smarter decisions and business growth.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <OfferingsTabs />

      {/* section 2 */}
      <CaseStudies/>

      <GetInTouch heading="Decode Data. Drive Results." headingColMd={8} buttonColMd={4} />
    </div>
  );
};

export default DataAnalytics;
